import type { OrganisationAccountingCategory } from '@my/directory-api';

/**
 * Options for an accounting-category picker: a first "empty" option (none on
 * the cargo definition, inherit on a product), then the ACTIVE categories as
 * "CODE — Name". The value stored is the CODE — what lines carry.
 *
 * A code already stored that is not in the list (a category since made
 * inactive or deleted) stays as an extra, flagged option, so the select does
 * not fall back to the first option and a save does not quietly change it.
 */
export function categoryOptions(
  categories: OrganisationAccountingCategory[],
  current: string,
  emptyLabel: string,
  notInListLabel: (code: string) => string,
): Array<{ value: string; label: string }> {
  const active = categories
    .filter((c) => c.status === 'Active')
    .sort((a, b) => a.displayOrder - b.displayOrder || a.code.localeCompare(b.code));
  const options = [
    { value: '', label: emptyLabel },
    ...active.map((c) => ({ value: c.code, label: `${c.code} — ${c.name}` })),
  ];
  if (current && !active.some((c) => c.code === current)) {
    options.push({ value: current, label: notInListLabel(current) });
  }
  return options;
}
